import angular from "angular";

class ModalPreviewAnnouncementCtrl {

    /* @ngInject */
    constructor(logger) {
        this.logger = logger;
    }

    $onInit() {
        this.content = this.resolve.content;
        this.announcement = this.resolve.announcement;
        this.announcementTransmitter = this.getAnnouncementTransmitter();
        this.open = false;
    }

    /** Fournit l'emetteur du communiqué */
    getAnnouncementTransmitter() {
        const transmitterByDefault = 'SY by Cegedim';
        return this.announcement.communitySelected != null ? this.announcement.communitySelected.name : transmitterByDefault;
    }

    goToPicLink(url) {
        if (url) {
            if (url.indexOf('http') == -1) {
                url = 'http://' + url;
            }
            window.open(url);
        }
    }

    close() {
        this.modalInstance.close();
    }

}

angular.module('app.announcement').component('modalPreviewAnnouncement', {
    templateUrl: require('./modal-preview-announcement.html'),
    controller: ModalPreviewAnnouncementCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<'
    }
});
